import { R } from '@core/utils/r';
import { Endpoint } from '../endpoint';
import { NotifiableSettingType, NotificationSettingResponse, NotificationSettingType } from '@business/entities/notification_settings';

export function fetchNotificationSettings(notifiableType: NotifiableSettingType, notifiableId: string, type?: NotificationSettingType) {
  return Endpoint.get<NotificationSettingResponse[]>(`@gc/notification-settings`, {
    params: R.objectCompact({
      notifiableType: notifiableType,
      notifiableId: notifiableId,
      type: type,
    }),
  });
}

export function updateNotificationSettings(
  notifiableType: NotifiableSettingType,
  notifiableId: string,
  type: NotificationSettingType,
  settings: { [key: string]: boolean },
) {
  return Endpoint.patch<NotificationSettingResponse>(`@gc/notification-settings`, {
    data: {
      notifiableType: notifiableType,
      notifiableId: notifiableId,
      type,
      settings,
    },
  });
}
